<div [class]="'d-flex align-items-center justify-content-'+position">
    {{price.toFixed(2)}} <span>{{currency}}</span>
</div>